/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import FillRequiredFieldsAction from './FillRequiredFieldsAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import SkipRequiredFieldsAction from './SkipRequiredFieldsAction/index'
import TreatmentFields from './TreatmentFields/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Actions/MissingRequiredTreatmentFields/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
 size="medium"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceS}
 text="Missing required treatment fields"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 marginBottom={dtSpaceXs}
 text="Please provide the following required treatment fields before unseating the patient:"
/>
<TreatmentFields
  viewPath={`${viewPath}/TreatmentFields`}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bblr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pt-6-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-7-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-8-Z1Yf8zk': dtColorsWhite,'--bc-9-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal1}`}
>
<SkipRequiredFieldsAction
  viewPath={`${viewPath}/SkipRequiredFieldsAction`}
/>
<FillRequiredFieldsAction
  viewPath={`${viewPath}/FillRequiredFieldsAction`}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}